import { Lock, User, Clock } from 'react-feather';
import { Nav, NavItem, NavLink, Spinner } from 'reactstrap';
import { Link } from 'react-router-dom';
import { MdAssignment, MdOutlineDocumentScanner } from 'react-icons/md';
import { useEffect, useState } from 'react';
import { Can } from '../../../utility/context/Can';

export const Tabs = ({ activeTab, toggleTab }) => {
  const [data, setData] = useState(null);

  useEffect(() => {
    setData(JSON.parse(localStorage.getItem('userData')));
  }, []);

  return (
    <Nav className="nav-left" pills vertical>
      <NavItem>
        <NavLink active={activeTab === '1'} onClick={() => toggleTab('1')}>
          <User size={18} className="mr-1" />
          <span className="font-weight-bold">Perfil</span>
        </NavLink>
      </NavItem>
      <NavItem>
        <NavLink active={activeTab === '2'} onClick={() => toggleTab('2')}>
          <Lock size={18} className="mr-1" />
          <span className="font-weight-bold">Mudar senha</span>
        </NavLink>
      </NavItem>
      <Can I="view_audit">
        <NavItem>
          <NavLink active={activeTab === '5'} onClick={() => toggleTab('5')}>
            <Clock size={18} className="mr-1" />
            <span className="font-weight-bold">Auditoria de ações</span>
          </NavLink>
        </NavItem>
      </Can>

      {/* <NavItem>
        <NavLink
          active={activeTab === '3'}
          onClick={() => toggleTab('3')}
          className="d-flex justify-content-between"
        >
          <div>
            <MdOutlineDocumentScanner size={18} className="mr-1" />
            <span className="font-weight-bold">Enviar Documentos</span>
          </div>
          {data?.verify_documents === 0 ? (
            <div>
              <Spinner color="warning" size="sm" type="grow">
                !
              </Spinner>
            </div>
          ) : null}
        </NavLink>
      </NavItem> */}
      <NavItem>
        <NavLink active={activeTab === '4'} tag={Link} to="/contract/merchant">
          <MdAssignment size={18} className="mr-1" />
          <span className="font-weight-bold">Contrato Termos de Serviço</span>
        </NavLink>
      </NavItem>
    </Nav>
  );
};
